import UserClient from "./userClient";
import axios from "axios";

export default class DirectorClient extends UserClient {
  constructor() {
    super("director");

    this.httpClient = axios.create({
      baseURL: `${process.env.VUE_APP_APIURL}/api/app/director`,
      headers: { Authorization: `${this.access_token}` }
    });
  }

  async join(params) {
    return this.httpClient
      .post("join", {
        member: params.member,
        corp: params.corp
      })
      .then(res => res.data);
  }

  async addCorp(params) {
    return this.httpClient.put("corp-add", params).then(res => res.data);
  }

  async applyCorp(params) {
    return this.httpClient
      .put("corp-apply-change", params)
      .then(res => res.data);
  }
}
